import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Checkbox,
  Typography,
  Collapse,
  IconButton,
  CircularProgress,
  capitalize,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Navbar from "../../components/common/Navbar";

function MapReports() {
  const theme = useTheme();
  const styles = useStyles(theme);

  // For selecting users and managing report selection state (dummy data for now)
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedReports, setSelectedReports] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Dummy users and reports data
  const users = ["John Doe", "Jane Smith", "Michael Scott"];
  const reports = [
    "Sales Report",
    "Employee Performance",
    "Inventory Report",
    "Revenue Report",
  ];

  // Handle selecting users
  const handleUserChange = (event) => {
    setSelectedUser(event.target.value);
  };

  // Handle individual report checkbox toggle
  const handleReportToggle = (reportName) => {
    setSelectedReports((prevSelectedReports) =>
      prevSelectedReports.includes(reportName)
        ? prevSelectedReports.filter((name) => name !== reportName)
        : [...prevSelectedReports, reportName]
    );
  };

  // Handle "Select All" checkbox toggle
  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setSelectedReports(isChecked ? reports : []);
  };
  return (
    <>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none" href="/">
                  Home
                </Link>
                <Link underline="none" href="/Employee">
                  Employee
                </Link>
                <Link underline="none" href="/">
                  Map Reports
                </Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {/* Main content area */}
      <Box sx={styles.box_container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                Map Reports
              </Typography>
            </Box>
          </Grid>
          {/* Left Section: User Selection Dropdown + Confirm Button */}
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            <Box
              sx={{
                ...styles.col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                textAlign: "left",
                padding: 2,
                marginLeft: 0,
              }}
            >
              <FormControl fullWidth size="small">
                <InputLabel>Select User</InputLabel>
                <Select
                  value={selectedUser}
                  onChange={handleUserChange}
                  label="Select User"
                >
                  {users.map((user, index) => (
                    <MenuItem key={index} value={user}>
                      {user}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  marginTop: 2,
                  width: "20%",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ ...styles.btn_primary, marginTop: 2 }}
                  disabled={!selectedUser || selectedReports.length === 0}
                >
                  Confirm
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Right Section: Select All Checkbox + Mapped Reports */}
          <Grid
            item
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            sx={{
              height: "100%",
              maxHeight: "70vh",
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.background.paper,
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                textAlign: "left",
                borderRadius: "4px",
                padding: 0,
              }}
            >
              <FormControl>
                <Box display="flex" alignItems="center">
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAll}
                    color="primary"
                  />
                  <Typography>Select All</Typography>
                </Box>
              </FormControl>

              {/* Mapped Reports with Checkboxes in Two Columns */}
              <Box sx={{ width: "100%", paddingTop: 2 }}>
                <Grid container spacing={2}>
                  {reports.map((report, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={selectedReports.includes(report)}
                          onChange={() => handleReportToggle(report)}
                          color="primary"
                        />
                        <Typography>{report}</Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      ;
    </>
  );
}

export default MapReports;
